module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("办理房屋抵押须知")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('scroller', {
    ref: "scroller"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "process"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("办理流程")]), _vm._v(" "), _c('div', {
    staticClass: "wraper-process"
  }, [_c('div', {
    staticClass: "inner-process"
  }, [_c('h3', {
    staticClass: "inner-title"
  }, [_vm._v("申请")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt"
  }, [_vm._v("\n                登记申请人持申请材料到房屋登记部门申请房屋登记。\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-process"
  }, [_c('h3', {
    staticClass: "inner-title"
  }, [_vm._v("受理")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt"
  }, [_vm._v("\n                登记部门查验申请主体和申请材料，并就有关事项询问申请人。对准予受理的，出具受理通知书。\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-process"
  }, [_c('h3', {
    staticClass: "inner-title"
  }, [_vm._v("领证")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt"
  }, [_vm._v("\n                权利人或者申请房屋登记的代理人在房屋登记大厅领证窗口领取房屋权属证明书或登记证明。\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "material"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("申报材料")]), _vm._v(" "), _c('div', {
    staticClass: "wraper-material"
  }, [_c('div', {
    staticClass: "inner-material",
    class: {
      hide: _vm.hideIdentity
    }
  }, [_c('h3', {
    staticClass: "material-title"
  }, [_vm._v("申请人身份证明")]), _vm._v(" "), _c('div', {
    staticClass: "inner-content"
  }, [_c('p', {
    staticClass: "inner-title"
  }, [_vm._v("境内自然人：")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt"
  }, [_vm._v("居民身份证，未成年人为居民身份证或户口簿；")]), _vm._v(" "), _c('p', {
    staticClass: "inner-title"
  }, [_vm._v("中华人民共和国香港、澳门特别行政区自然人：")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt"
  }, [_vm._v("香港、澳门特别行政区居民身份证或者香港、澳门特别行政区护照；")]), _vm._v(" "), _c('p', {
    staticClass: "inner-title"
  }, [_vm._v("中华人民共和国台湾地区自然人：")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt"
  }, [_vm._v("台湾居民来往大陆通行证；")]), _vm._v(" "), _c('p', {
    staticClass: "inner-title"
  }, [_vm._v("华侨：")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt"
  }, [_vm._v("中华人民共和国护照和国外长期居留身份证件；")]), _vm._v(" "), _c('p', {
    staticClass: "inner-title"
  }, [_vm._v("外籍自然人：")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt"
  }, [_vm._v("中国政府主管机关签发的居留证件或者其所在国护照、译文公证；")]), _vm._v(" "), _c('p', {
    staticClass: "inner-title"
  }, [_vm._v("境内机关法人、事业单位法人、社团法人：")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt"
  }, [_vm._v("组织机构代码证；")]), _vm._v(" "), _c('p', {
    staticClass: "inner-title"
  }, [_vm._v("境内企业法人：")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt"
  }, [_vm._v("企业法人营业执照；")]), _vm._v(" "), _c('p', {
    staticClass: "inner-title"
  }, [_vm._v("境内其他组织：")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt"
  }, [_vm._v("营业执照或者组织机构代码证；")]), _vm._v(" "), _c('p', {
    staticClass: "inner-title"
  }, [_vm._v("境外（含港澳台，下同）法人、其他组织：")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt"
  }, [_vm._v("其成立的批准文件，或注册证明，或商业登记证；")]), _vm._v(" "), _c('p', {
    staticClass: "inner-title"
  }, [_vm._v("外国驻华使（领）馆和外国驻华办事机构、国际组织驻华代表机构：")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt"
  }, [_vm._v("该使（领）馆、办事机构、代表机构出具的身份证明。")])])]), _vm._v(" "), (_vm.hideIdentity) ? _c('div', {
    staticClass: "inner-btn",
    on: {
      "click": _vm.showIdentity
    }
  }, [_c('div', {
    staticClass: "btn"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "wraper-material"
  }, [_c('div', {
    staticClass: "inner-material",
    class: {
      hide: _vm.hideApprove
    }
  }, [_c('h3', {
    staticClass: "material-title"
  }, [_vm._v("委托、公证和认证")]), _vm._v(" "), _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "inner-txt-b"
  }, [_vm._v("\n                  委托代理人登记的，提交授权委托书、委托双方身份证明。授权委托书应当明确委托事项、权限；注明委托期限的，申请登记时间应当在委托期限内。委托人是法人或者其他组织的，应当加盖公章并注明日期；委托人是自然人的，应当签字并注明日期。授权委托书经公证的，可不再提交委托人的身份证明原件。\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt-b"
  }, [_vm._v("\n                  抵押权（含最高额抵押权）设立登记中抵押人为自然人的（抵押权人为金融机构或者北京市住房贷款担保中心的除外），委托代理人代为申请的，应提交经公证的授权委托书。\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt-b"
  }, [_vm._v("\n                  未成年人的房屋，应当由其监护人代为申请登记。监护人代为申请时，应当提交本人和未成年人的身份证明、监护关系证明,未成年子女及父母的户口本，因处分未成年人房屋申请登记的，监护人还应当提供为未成年人利益处分房屋的书面保证。父母之外其他监护人处分未成年人房屋申请登记的，其对未成年人享有监护权的证明应当经公证或者认证，但人民法院、居委会（村委会）或者未成年人父、母所在单位指定监护的除外。\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt-b"
  }, [_vm._v("\n                  香港、澳门、台湾及外国申请人委托他人申请房屋登记的，其授权委托书应当经公证或者认证。其中，香港、澳门地区出具的公证书应当由中国法律服务(香港或者澳门)有限公司加盖转递专用章；台湾地区出具的公证书应当由北京市公证协会确认；外国出具的公证文书应当经中国驻该国使(领)馆认证，与中国没有外交关系的国家，应当经该国和中国都有外交关系的第三国的中国使(领)馆认证。\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt-b"
  }, [_vm._v("\n                  除委托、声明、遗嘱等单方法律行为外，其他涉及房屋的公证应当由本市公证机构出具。\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt-b"
  }, [_vm._v("\n                  当事人约定合同经公证生效的，应当提交有关合同的公证文书原件。\n                ")])])]), _vm._v(" "), (_vm.hideApprove) ? _c('div', {
    staticClass: "inner-btn",
    on: {
      "click": _vm.showApprove
    }
  }, [_c('div', {
    staticClass: "btn"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "wraper-material"
  }, [_c('div', {
    staticClass: "inner-material",
    class: {
      hide: _vm.hideOther
    }
  }, [_c('h3', {
    staticClass: "material-title"
  }, [_vm._v("其他要求")]), _vm._v(" "), _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "inner-txt-b"
  }, [_vm._v("\n                  申请材料注明原件的，申请人应当提交申请材料原件。申请材料未注明原件的，申请人应当提交申请材料复印件，并提供申请材料原件供登记部门核验。要求提交申请材料原件，申请人不能提交原件的，可以提交出具该原件的机关或者法定存档机构确认与原件一致的复印件，或者公证机构公证的复印件与原件一致的证明。\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt-b"
  }, [_vm._v("\n                  房屋登记申请书应当由申请人（代理人）签字确认。申请人是法人或者其他组织的，由代理人签字，可不加盖公章；申请人是自然人的，由申请人（代理人）签字。\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt-b"
  }, [_vm._v("\n                  申请登记材料应当使用汉字文本，外文文本的申请材料应当附经公证或认证的汉字译本。"), _c('br'), _vm._v(" "), _c('span', [_vm._v("（填写申请材料应当使用黑色或者蓝黑色钢笔、签字笔，书写内容清晰工整，不得使用修正液等进行修改。确需修改的，申请人应当在修改处签字确认。）")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt-b"
  }, [_vm._v("\n                  申请人应当就有关事项接受登记部门询问并如实回答，在确认询问结果后，在询问笔录上签署姓名和日期。代理人代为接受询问的，代理人应当明确代某个申请人接受询问。\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt-b"
  }, [_vm._v("\n                  共有的房屋，应当由共有人共同申请登记。共有人应当书面约定共有方式；按份共有的，还应当明确共有人各自占有的份额。夫妻共同申请房屋登记的，应提交婚姻关系证明。"), _c('br'), _vm._v(" "), _c('span', [_vm._v("（婚姻关系证明应当为《结婚证》。无法提供《结婚证》的，申请人应当向婚姻登记部门申请补领。无法补领的，可提供婚姻登记部门出具的婚姻登记证明，或者经公证（或者认证）的婚姻状况证明，或者有权部门出具的证明材料。）")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt-b"
  }, [_vm._v("\n                  以下材料可作为监护关系证明使用：户口簿、婚姻关系证明；出生医学证明；人民法院指定监护人的生效判决；居民委员会、村民委员会指定监护人的证明文件；证明监护关系的公证书；未成年人的父、母的所在单位指定监护人的证明文件。\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "inner-txt-b"
  }, [_vm._v("\n                  用于申请房屋登记的境外司法文书应当经有管辖权的北京市中级人民法院裁定予以认可和执行。"), _c('br'), _vm._v(" "), _c('span', [_vm._v("（各区的执行标准会有差异，具体参照各区要求或咨询各区专员）")])])])]), _vm._v(" "), (_vm.hideOther) ? _c('div', {
    staticClass: "inner-btn",
    on: {
      "click": _vm.showOther
    }
  }, [_c('div', {
    staticClass: "btn"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")])])]) : _vm._e()])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5cb1f4d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/discover/instructions.vue
// module id = 356
// module chunks = 1